export const VALIDATION_CONST = {
	//Date/Year
	MIN_DATE: "1900-01-01T00:00:00.000+13:00", // Resolving issue with timezone difference
	YEAR_MAX: 9999,
	//Number
	INT_1: 1,
	INT_8: 8,
	INT_24: 24,
	INT_100: 100,
	INT_999: 999,
	INT_TINY: 200,
	FLOAT_2_6: 2.6,
	FLOAT_10: 10.0,
	FLOAT_TINY: 99.99,
	INT_SMALL: 30000,
	FLOAT_SMALL: 30000.99,
	INT_MAX: 2147483647,
	FLOAT_MAX: 999999.99,
	//String
	NVARCHAR_5: 5,
	NVARCHAR_10: 10,
	NVARCHAR_15: 15,
	NVARCHAR_16: 16,
	NVARCHAR_20: 20,
	NVARCHAR_50: 50,
	NVARCHAR_100: 100,
	NVARCHAR_150: 150,
	NVARCHAR_200: 200,
	NVARCHAR_500: 500,
	NVARCHAR_1000: 1000,
	NVARCHAR_MAX: 4000,
	POSTCODE_MAX: 4
};
